export const projects = [
    {
    id: 14,
    name: "Author Page",
    url: "https://ruslana-pidsadiuk-author-site.vercel.app/",
    source: "https://github.com/lanachayka/ruslana_pidsadiuk_author_site",
    photo: "author-page.png",
    technologies: ["Next", "React", "Tailwind CSS"],
    description:
      "Next application - author page. Contains information about the author, his works and contacts. Created with the use of Tailwind CSS.",
  },
  {
    id: 13,
    name: "Food Next App",
    url: "https://food-next-app-ten.vercel.app/",
    source: "https://github.com/lanachayka/food-next-app",
    photo: "food-next-app.png",
    technologies: ["Next", "React"],
    description:
      "Full Stack Next application. Allow you browse users meals and share yours.",
  },
  {
    id: 3,
    name: "Fashion House",
    url: "https://lanachayka.github.io/fashion-house/",
    source: "https://github.com/lanachayka/fashion-house",
    photo: "fashion-house.png",
    technologies: ["React", "TypeScript", "CSS", "React Testing Library"],
    description:
      "Fashion shop website which contains 8 pages. Data management based on React Context. Unit testing for components created by using React Testing Library.",
  },
  {
    id: 0,
    name: "Plant Shop",
    url: "https://lanachayka.github.io/plant_shop/",
    source: "https://github.com/lanachayka/plant_shop",
    photo: "plant-shop.png",
    technologies: ["HTML", "CSS", "JS", "Bootstrap"],
    description:
      "The site-shop which contains 10 pages. With the use of JS implemented: shopping cart, interactive change of photos according to the subject. Implemented modal window, dropdowns from Bootstrap.",
  },
  {
    id: 1,
    name: "Happy Hostel",
    url: "https://lanachayka.github.io/happy-hostel/",
    source: "https://github.com/lanachayka/happy-hostel",
    photo: "happy-hostel.png",
    technologies: ["HTML", "CSS", "JS", "Bootstrap"],
    description:
      "Website - business card of the hotel. With the use of JS implemented: interactive photo gallery, generating information about numbers from a JSON file. Implemented forms, carousel, modal window from Bootstrap.",
  },
  {
    id: 2,
    name: "Space Travel",
    url: "https://lanachayka.github.io/space-travel/",
    source: "https://github.com/lanachayka/space-travel",
    photo: "space-travel.png",
    technologies: ["HTML", "CSS", "JS"],
    description:
      "Website about space traveling. Contains 4 pages. Tabs functionality implemented with the use of JS.",
  },
  {
    id: 12,
    name: "Event Calendar",
    url: "https://lanachayka.github.io/event-calendar/",
    source: "https://github.com/lanachayka/event-calendar",
    photo: "event-calendar.png",
    technologies: ["React", "Redux", "TypeScript", "Ant design"],
    description:
      'Event Calendar App. Login and Logout ability by using "user", "admin", "timur" usernames and password "123". After login implemented the ability to create events and invite guests. ',
  },
  {
    id: 4,
    name: "Country List",
    url: "https://lanachayka.github.io/country-list/",
    source: "https://github.com/lanachayka/country-list",
    photo: "country-list.png",
    technologies: [
      "React",
      "GraphQL",
      "Typescript",
      "React Testing Library",
      "Enzyme",
    ],
    description:
      "Website with information about countries. Data is displayed using GraphQL Apollo Client. Realized search and output of details. Unit testing created by using Enzyme and React Testing Library.",
  },
  {
    id: 5,
    name: "URL Shortening App",
    url: "https://lanachayka.github.io/url-shortening/",
    source: "https://github.com/lanachayka/url-shortening",
    photo: "shortly.png",
    technologies: ["React", "TypeScript", "Sass", "Rest Api"],
    description:
      "This landing page allows you to short and copy links. Integrate with the shrtcode URL shortening API.",
  },
  {
    id: 6,
    name: "Markdown Notes",
    url: "https://lanachayka.github.io/markdown-note/",
    source: "https://github.com/lanachayka/markdown-note",
    photo: "markdown-notes.png",
    technologies: ["React", "TypeScript", "Bootstrap"],
    description:
      "Application for creating notes with markdown support. Addition functions: manage notes and tags, filtering notes by tags or title. Data storage in localStorage by the custom hook.",
  },
  {
    id: 7,
    name: "Huddle",
    url: "https://lanachayka.github.io/huddle-styled-components/",
    source: "https://github.com/lanachayka/huddle-styled-components",
    photo: "huddle.png",
    technologies: ["React", "Styled-Components"],
    description:
      "Simple landing page created by using react styled-components with theme-switching functionality.",
  },
  {
    id: 8,
    name: "Converter",
    url: "https://lanachayka.github.io/converter/",
    source: "https://github.com/lanachayka/converter",
    photo: "converter.png",
    technologies: ["React", "TypeScript"],
    description:
      "Units converter (length, weight, temperature) based on React and TypeScript. Functionality: conversion drop-down list, date and time.",
  },
  {
    id: 10,
    name: "Weather App",
    url: "https://lanachayka.github.io/weather-app/",
    source: "https://github.com/lanachayka/weather-app",
    photo: "weather-app.png",
    technologies: ["React", "Redux Toolkit", "Less"],
    description:
      "Weather forecast site. Data processing from the server is implemented with Redux Toolkit. The preprocessor Less is used for styles.",
  },
  {
    id: 11,
    name: "Quiz",
    url: "https://lanachayka.github.io/quiz/",
    source: "https://github.com/lanachayka/quiz",
    photo: "quiz.png",
    technologies: ["React", "Redux"],
    description:
      "Website - quiz based on React and Redux. Opportunities to choose a topic and pass the quiz.",
  },
];
